// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2xhvc","name":"ConsentHeader_name__3puEn","birthday":"ConsentHeader_birthday__3qShg","skeleton":"ConsentHeader_skeleton__PXeY6"};